import { useEffect } from 'react';

import { useNotifications } from '@store/notifications';

const URL = '/api/auth/verify-change-password-token';

export const useVerifyToken = (token: string | null) => {
  const { addNotification } = useNotifications();

  useEffect(() => {
    if (!token) {
      return;
    }

    async function checkVerificationToken() {
      const response = await fetch(URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          token,
        }),
      });

      const result = await response.json();

      if (result.status === 'error') {
        addNotification(result.message, 'error');
      }
    }

    checkVerificationToken();
  }, [token]);
};
